//Module Keys
let locales = {};

//Merge Views
import main from 'Modules/scheduledActions/views/main/lan/en';
import deleteScheduledAction from 'Modules/scheduledActions/views/components/deleteScheduledAction/lan/en';
import editScheduledAction from 'Modules/scheduledActions/views/components/editScheduledAction/lan/en';
import scheduledActionsTab from 'Modules/scheduledActions/views/components/tab/lan/en';

locales = {
    ...locales,
    ...main,
    ...deleteScheduledAction,
    ...editScheduledAction,
    ...scheduledActionsTab,
};


export default locales;